import { IApplicationState } from '../../types/redux';

export function getIsFloorPlanAvailable(state: IApplicationState) {
  return state.newbuilding.isFloorPlanAvailable;
}
